import { render, staticRenderFns } from "./ComputedTime.vue?vue&type=template&id=fd3feaa6&"
import script from "./ComputedTime.vue?vue&type=script&lang=ts&"
export * from "./ComputedTime.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports